import CategoriesSection from '../components/CategoriesSection';

const BrowsePage = () => <CategoriesSection />;

export default BrowsePage;